/* eslint-disable camelcase */
const nl = {
  common: {
    copied: 'Gekopieërd',
    course: {
      zero: '%{courses_capitalized}',
      one: '%{course_capitalized}',
      other: '%{courses_capitalized}'
    },
    follower: {
      zero: 'Volgers',
      one: 'Volger',
      other: 'Volgers'
    },
    leader: {
      zero: 'Leiders',
      one: 'Leider',
      other: 'Leiders'
    }
  },
  joi: {
    fields: {
      date_of_birth: 'Geboortedatum',
      email: 'E-mailadres',
      partner_email: 'Partner e-mailadres',
      first_name: 'Voornaam',
      last_name: 'Achternaam',
      phone: 'Telefoonnummer',
      student: '%{member_capitalized}',
      role: 'Rol',
      partner_gegevens: 'Partner gegevens',
      woonplaats: 'Woonplaats',
      hoe_heb_je_ons_gevonden: 'Hoe heb je ons gevonden?',
      fields_name: 'Veldnaam',
      fields_id: 'Veld ID',
      fields_type: 'Veld type',
      fields_mandatory: 'Verplicht',
      fields_category: 'Categorie',
      fields_value: '%{name}',
    },
    templates: {
      base: '%{field} %{message}'
    },
    string: {
      base: 'mag alleen tekst bevatten.',
      empty: 'mag niet leeg zijn.',
      min: 'moet ten minste %{number} tekens bevatten.',
      max: 'mag maximaal %{number} tekens bevatten.',
      length: 'heeft niet de exacte lengte.',
      email: 'is geen geldig e-mailadres.',
      regex: {
        base: 'komt niet overeen met het verwachte patroon.'
      },
      restricted_email: 'mag niet hetzelfde zijn als koper.',
      invalid_email: 'is ongeldig.'
    },
    number: {
      base: 'moet een getal zijn.',
      min: 'is kleiner dan het minimale toegestane getal.',
      max: 'is groter dan het maximale toegestane getal.',
      integer: 'is geen integer.'
    },
    date: {
      base: 'is geen geldige datum.',
      min: 'is voor de vroegst toegestane datum.',
      max: 'is na de laatst toegestane datum.'
    },
    boolean: {
      base: 'is geen boolean.'
    },
    array: {
      base: 'is geen array.',
      min: 'heeft minder items dan het minimum.',
      max: 'heeft meer items dan het maximum.'
    },
    object: {
      base: 'is geen object.',
      unknown: 'bevat niet toegestane sleutels.'
    },
    any: {
      invalid: 'bevat een ongeldig teken.',
      required: 'is niet opgegeven.',
      only: 'komt niet overeen met de toegestane waarden.'
    }
  },
  installments: {
    delete_failed: 'Verwijderen is niet gelukt. Probeer het opnieuw.'
  },
  mailings: {
    editor: {
      first_name: 'Voornaam',
      last_name: 'Achternaam',
      placeholders: 'Placeholders'
    }
  },
  payment_form: {
    on_waitlist: 'Op wachtlijst',
    people_waiting: {
      one: '1 persoon op de wachtlijst',
      other: '%{count} mensen op de wachtlijst'
    },
    discount_code: {
      check: 'Controleren'
    },
    payments: {
      new: {
        alerts: {
          select_bank: 'Selecteer je bank',
          select_plan: 'Selecteer het betaalplan',
          agree_terms: 'Om verder te kunnen dien je akkoord te zijn met de voorwaarden'
        },
        ideal_terms: 'Ik ga akkoord met een afschrijving van %{amount} van mijn IBAN elke periode.',
        credit_card_terms: 'Ik ga akkoord met een afschrijving van %{amount} van mijn creditcard elke periode.'
      }
    },
    utils: {
      texts: {
        available: 'Beschikbaar',
        select_course: 'Selecteer %{number} %{object} die je wilt volgen',
        student_explanatory: 'Voer je gegevens in',
        student_explanatory_student: 'Gegevens kind (de %{member})',
        partner_explanatory: 'Voer je partner gegevens in',
        partner_explanatory_student: 'Partner gegevens',
        spots_left: {
          zero: '0 plekken beschikbaar',
          one: '1 plek beschikbaar',
          other: '%{count} plekken beschikbaar'
        },
        starts_on: 'Start op',
        waitlist: 'Inschrijven op wachtlijst',
        trial_class: '%{trial_class_capitalized}',
        waitlisted: 'Op dit moment is het niet mogelijk om in te schrijven als %{role1}, ' +
                    'omdat we streven naar een evenwichtige verdeling in de %{class}. ' +
                    'Zodra een nieuwe %{role2} zich inschrijft, komt er een plek vrij.',
        couple_available: 'Beschikbaar als koppel',
        couple_not_available: 'Niet beschikbaar',
        couple_leader_title: 'Jouw gegevens',
        couple_leader_explanatory: 'Vul je gegevens in als Leader',
        couple_follower_title: 'Partner gegevens',
        couple_follower_explanatory: 'Vul de gegevens van de Follower in',
      }
    },
    errors: {
      no_more_spots: 'Sorry, geen plekken meer beschikbaar',
      no_spots_left_for: 'Sorry, geen plekken meer beschikbaar voor %{role}',
      no_dance_class_selected: 'Selecteer minimaal één %{course} of klik op \'Kies later\''
    }
  }
};
/* eslint-enable camelcase */

export default nl;
